import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LoginUserService } from '../../../../core/services/login-user.service';
import { IMAGE_BASE__URL } from '../../../../core/services/CusHttp';
@Component({
  selector: 'app-download-modal',
  templateUrl: './download-modal.component.html',
  styleUrls: ['./download-modal.component.scss']
})
export class DownloadModalComponent implements OnInit {
  @Input() display: boolean;
  @Input() resumeId: string;
  @Output() isDisplay: any = new EventEmitter();
  public selectDownloadType: string = 'html';
  IMAGE_BASE__URL = IMAGE_BASE__URL;
  public token: string;//
  constructor(
    public _login: LoginUserService
  ) {
    this.token = this._login.getToken();
    this._login.token$.subscribe((resp: string) => {
      this.token = resp;
    });
  }
  ngOnInit() {

  }
  //下载格式选择框
  targetIsOpen() {
    this.display = false;
    this.isDisplay.emit(this.display);

  }
  targetType(event) {
    this.selectDownloadType = event;
  }

}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/user/student/student-resume/download-modal/download-modal.component.ts